/* Copyright (C) ZibatRan, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Zibatran development team, Dec 2020
 */

import React, {useEffect, useState} from "react";
import {Button, Card, Pagination, Select} from "antd";
import {GlobalAPIRoutes, PublicAPIRoutes} from "../../api/APIRoutes";
import placeholder from "../../assets/images/placeholder.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCircle} from "@fortawesome/free-solid-svg-icons";
import {getData} from "../../api/Interface";
import {useLocation, useHistory} from "react-router-dom";
import {Option} from "antd/es/mentions";
import moment from "jalali-moment";

export default function EventList() {

    const [EventItems, setEventItems] = useState([]);
    const [loading, setLoading] = useState(false);
    const history = useHistory();

    function useQuery() {
        return new URLSearchParams(useLocation().search);
    }
    let query = useQuery();


    useEffect(() => {
        getItems();
    }, [query.get("page")]);

    const getItems = async () => {
        setLoading(true);
        let response = await getData(`${PublicAPIRoutes.GetEvents}?page=${(query.get("page") || 1)}`);
        if (response) {
            setEventItems(response.data);
        }
        setLoading(false)
    };

    return (
<>
        <div className="row col-xl-12 col-lg-12 col-md-12 col-12 justify-content-center">
            <div className=" col-xl-12 col-lg-12 col-md-12 col-12  justify-content-center"
                 style={{
                     marginTop: 20,
                     backgroundColor: '#FFFFFF',
                     borderRadius: '20px',
                     padding: 20
                 }}
            >

                <h3 className="col-xl-12 col-lg-12 col-md-12 col-12 text-center font-weight-bold">
                    رویداد ها
                </h3>
<hr/>
                <h4>جستجو</h4>
                <div className="row">
                    <div className="col col-4">
                        <Select className="form-control" placeholder="دسته بندی">
                            <Option value="1">والدگری</Option>
                            <Option value="2">کودک</Option>
                            <Option value="3">درسی</Option>
                            <Option value="4">رایانه</Option>
                            <Option value="5">فوق‌برنامه</Option>
                            <Option value="6">سازمانی</Option>
                            <Option value="7">زبان خارجی</Option>
                            <Option value="8">هنری</Option>
                            <Option value="9">ورزشی</Option>
                            <Option value="10">مهارتی</Option>
                            <Option value="11">روان‌شناسی و موفقیت</Option>
                            <Option value="12">سرمایه‌گذاری</Option>
                            <Option value="13">کسب‌وکار</Option>
                            <Option value="14">سایر آموزش‌های سفارشی</Option>
                        </Select>
                    </div>
                    <div className="col col-4">
                        <input type="text" className="form-control" name="q" placeholder="متن جستجو را وارد کنید"/>
                    </div>
                    <div className="col col-4">
                        <button className="btn btn-success" >جستجو</button>
                    </div>

                </div>
            </div>
        </div>

    <div className="row col-xl-12 col-lg-12 col-md-12 col-12 justify-content-center">
        <div className=" col-xl-12 col-lg-12 col-md-12 col-12  justify-content-center"
             style={{
                 marginTop: 20,
                 backgroundColor: '#FFFFFF',
                 borderRadius: '20px',
                 padding: 20
             }}
        >
        <div className="row py-3">

            {!loading && EventItems.data && EventItems.data.map((item, key) =>
                <div className="col-md-4 col-sm-4 col-6 my-3" key={key}>
                    <Card
                        className="heif-8 heif-md-6 heif-lg-6 heif-xl-6 b-15 my-2 my-sm-0"
                        hoverable
                        cover={
                            <>
                                <img className="img-fluid bt-15 img-card"
                                     src={item.thumb_image !== null ?
                                         item.thumb_image.s3_status === 2
                                             ? item.thumb_image.s3_file
                                             :  item.thumb_image.url
                                         : placeholder
                                     }/>
                            </>
                        }
                        onClick={() => history.push(`/event/${item.id}`)}
                    >
                        <div className="txt-right pb-5">
                            <span className="text-muted"> شروع {item.sessions[0] ? moment.unix(item.sessions[0].start_time).locale("fa").format("LLLL") : 'جلسه ای تعریف نشده'}</span><br/>
                            <span className="text-muted"><FontAwesomeIcon icon={faCircle}
                                                                          size="sm"/> {item.title}</span><br/>
                            <span className="text-muted"><FontAwesomeIcon icon={faCircle}
                                                                          size="sm"/> {item.sessionNumber} جلسه</span><br/>
                            <span className="text-muted"><FontAwesomeIcon icon={faCircle}
                                                                          size="sm"/> {item.remaining_capacity} ظرفیت باقی مانده</span><br/>
                            <span className="text-muted"><FontAwesomeIcon icon={faCircle}
                                                                          size="sm"/> {item.classInfo==='1' ? 'حضوری' : 'آنلاین'} </span><br/>
                            <span className="text-muted"><FontAwesomeIcon icon={faCircle}
                                                                          size="sm"/> {item.price} هزار تومان</span>
                        </div>
                        <div className="col-12 text-center card-footer">
                            <Button
                                className="col-12"
                                size={"middle"}
                                type={"primary"}
                            >مشاهده</Button>
                        </div>
                    </Card>
                </div>
            )}

            <div className="col-12 text-center my-3">
                {EventItems && EventItems.data && EventItems.last_page &&
                <Pagination
                    style={{direction: 'ltr', padding: 10}}
                    size="small"
                    total={EventItems.total}
                    current={query.get("page") ? parseInt(query.get("page")) : 1}
                    onChange={e => {
                        history.push(`${history.location.pathname}?page=${e}`)
                    }}
                />
                }
            </div>

        </div>
        </div>

    </div>
</>
    )
}